import { create } from 'zustand';

type Reward = {
  amount: number;
};

type Notification = {
  type: 'Success' | 'Error' | 'Warning';
  message: string;
  rewards?: Reward[];
  duration?: number; // Кастомная длительность в миллисекундах
};

type NotificationStore = {
  showNotification: boolean;
  notification: Notification;
  notificationQueue: Notification[];
  setNotification: (notification: Notification) => void;
  closeNotification: () => void;
};

let notificationTimer: NodeJS.Timeout | null = null;

export const useNotificationStore = create<NotificationStore>((set, get) => ({
  showNotification: false,
  notification: {
    type: 'Error',
    message: 'Something went wrong',
    rewards: [],
  },
  notificationQueue: [],

  setNotification: (notification) => {
    const { showNotification } = get();

    const startTimer = () => {
      if (notificationTimer) {
        clearTimeout(notificationTimer);
      }
      const duration = notification.duration || 3000; // Используем кастомную длительность или 3 секунды по умолчанию
      notificationTimer = setTimeout(() => {
        const state = get();
        if (state.notificationQueue.length > 0) {
          const [nextNotification, ...remainingQueue] = state.notificationQueue;
          set({
            notification: nextNotification,
            notificationQueue: remainingQueue,
            showNotification: true,
          });
          startTimer();
        } else {
          set({ showNotification: false });
        }
      }, duration);
    };

    if (showNotification) {
      set({ showNotification: false });
      setTimeout(() => {
        set((state) => ({
          notification: notification,
          notificationQueue: state.notificationQueue,
          showNotification: true,
        }));
        startTimer();
      }, 500);
    } else {
      set({
        showNotification: true,
        notification: notification,
        notificationQueue: [],
      });
      startTimer();
    }
  },

  closeNotification: () => {
    if (notificationTimer) {
      clearTimeout(notificationTimer);
      notificationTimer = null;
    }

    const state = get();
    if (state.notificationQueue.length > 0) {
      const [nextNotification, ...remainingQueue] = state.notificationQueue;
      set({
        notification: nextNotification,
        notificationQueue: remainingQueue,
        showNotification: true,
      });
      notificationTimer = setTimeout(() => {
        const currentState = get();
        if (currentState.notificationQueue.length > 0) {
          const [next, ...rest] = currentState.notificationQueue;
          set({
            notification: next,
            notificationQueue: rest,
            showNotification: true,
          });
        } else {
          set({ showNotification: false });
        }
      }, 1000);
    } else {
      set({ showNotification: false });
    }
  },
}));
